import imprimirIntencaoVendaSaga from './Imprimir/saga';
import cancelarIntencaoVendaSaga from './Cancelar/saga';
import incluirIntencaoVendaSaga from './Incluir/saga';
import consultarIntencaoVendaSaga from './Consultar/saga';

export const imprimirIntencaoVenda = imprimirIntencaoVendaSaga;
export const cancelarIntencaoVenda = cancelarIntencaoVendaSaga;
export const incluirIntencaoVenda = incluirIntencaoVendaSaga;
export const consultarIntencaoVenda = consultarIntencaoVendaSaga;
